<div *ngIf="myData().length">
    <select [(ngModel)]="info" *ngIf="myData().length > 1" class="form-control ">
            <option *ngFor="let d of myData()" [ngValue]="d.value">{{ d.name }}</option>
    </select>
    <dialog-info [info]="getVal(info || myData() [0].value)"></dialog-info>
</div>

<footer-close (submit)="onSubmit ()"></footer-close>